<div class="row">
  <div class="col-5 mb-3">
    <h2 class="title-list">{{ title }}</h2>
  </div>
  <div class="col btn-back text-end">
    <button class="btn btn-secondary" (click)="goBack()">Back</button>
  </div>
</div>
<div class="fw-bold bg-white p-5 rounded-5 mb-5">
  <div class="col-5 mb-3">
    <h3 class="fw-bold labelInformation">{{ information }}</h3>
  </div>
  <!-- Primera fila -->
  <div class="row mt-3">
    <div class="col">
      <label for="planName">Plan name<span class="green-asterisk">*</span></label>
      <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="planName" disabled />
    </div>
    <div class="col">
      <label for="typePlan" class="">Type of Plan<span class="green-asterisk">*</span></label>
      <select class="form-select dropdown input-label" [(ngModel)]="planTypeId" disabled id="typePlan" required>
         <option value="" disabled selected>Select a Plan Type</option>
        <option *ngFor="let planType of planTypes" [value]="planType.planTypeId">{{ planType.name }} / {{planType.frequencyId}} / {{planType.isPool ? 'Pool' : 'No Pool'}}</option>
        
      </select>
    </div>
  </div>

  <!-- Segunda fila -->
  <div class="row mt-3">
    <div class="col-md-3">
      <label for="qtyData" class="">Data<span class="green-asterisk">*</span></label>
      <input type="text" class="form-control input-label" [(ngModel)]="qtyData" disabled />
    </div>
    <div class="col-md-3">
      <label for="typeData">Type of Data</label>
      <select class="form-select dropdown input-label" [(ngModel)]="typeData" name="typeData" disabled>
        <option value="MB">MB</option>
        <option value="GB">GB</option>
      </select>
    </div>

    <div class="col-md-6">
      <label for="typeData" class="">Price<span class="green-asterisk">*</span></label>
      <input type="text" class="form-control input-label" placeholder="$ 0.00" (input)="checkFields()"
        [(ngModel)]="price" disabled />
    </div>
  </div>

  <!-- Tercera fila -->
  <div class="row mt-3">
    <div class="col">
      <label for="typeData" class="">Extra Fees</label>
      <input type="text" placeholder="$ 0.00" class="form-control input-label" (input)="checkFields()"
        [(ngModel)]="extraFee" disabled />
    </div>
    <div class="col">
      <label for="qtyData" class="">Description</label>
      <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="description" disabled />
    </div>
  </div>
  <div class="row mt-3">
  
    <div class="col">
      <label for="Carriers" class="">Carriers</label>

      <app-multi-select-control [items]="carriers" [selectedItems]="selectedCarriers" [disabled]="true" placeholder="Select carriers"
        ></app-multi-select-control>
    </div>
      <div class="col">
    </div>
  </div>


<!-- Cuarta fila -->
<div class="row mt-3">
  <div class="col">
    <input type="checkbox" class="checkbox" id="active" name="activePlan" [(ngModel)]="isActivePlan"
      [checked]="isActivePlan" disabled />
    <label style="margin-left: 10px;" for="active">Active</label>
  </div>
</div>
</div>